import { api } from "../api";

/**
 * identifierFindAllAllResponse - Function that finds on database all identifiers as list response data    
 * /identifiers/{managerId}/{status}/list  
 * method GET 
 * @async-function
 */
const identifierFindAllAllResponse = async (token: string, managerId: number, status: string) => {
    const response = await api.get(
        `/identifiers/${managerId}/${status}/list`, {
            headers: {
                'Authorization': `Bearer ${token}`
            }
         }
    );
    return response;
};

export default identifierFindAllAllResponse;